import { render, staticRenderFns } from "./mdLogo.vue?vue&type=template&id=4275054c&scoped=true&"
import script from "./mdLogo.vue?vue&type=script&lang=js&"
export * from "./mdLogo.vue?vue&type=script&lang=js&"
import style0 from "./mdLogo.vue?vue&type=style&index=0&id=4275054c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4275054c",
  null
  
)

export default component.exports